import { MediaQueries } from 'components/MediaQueries';
import { Sidenav } from 'pages/sidebar/SideBar.style';
import styled from 'styled-components';

export const HeaderStyle = styled.div`
  padding-top: env(safe-area-inset-top);
  background: ${({ theme }) => theme.Bg1};
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  box-shadow: ${({ theme }) =>
    theme.mode === 'light'
      ? 'rgba(99, 99, 99, 0.2) 0px 0px 8px 0px'
      : 'rgb(255 255 255 / 20%) 0px 0px 3px 0px'};
  transition: top 0.7s;
  .header {
    max-width: 1230px;
    margin: 0 auto;
    height: 55px;
    display: flex;
    align-items: center;
    width: 100%;
  }
  .logo-title {
    color: #2b99f5;
    font-size: 20px;
    text-align: start;
    margin: 0 8px 0 8px;
  }

  // search
  .header-brand {
    display: flex;
    align-items: center;
    cursor: pointer;
    svg {
      width: 35px;
      height: 35px;
    }
  }
  @media only screen and (max-width: 400px) {
    .company-brand {
      margin-top: 18px;
    }
    .logo-title {
      display: none;
    }
  }

  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    width: 100%;
  }

  .header-action-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .header-icon-block {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.border1};
    margin-right: 8px;
    &:hover {
      background-color: ${({ theme }) => theme.hoverBg1};
    }
  }

  .search-icon {
    svg {
      width: 18px;
      height: 18px;
      color: ${({ theme }) => theme.svg1};
    }
  }

  .notify-icon {
    display: none;
    position: relative;
    svg {
      width: 21px;
      height: 21px;
      fill: ${({ theme }) => theme.svg1};
    }
  }

  .notification-count {
    width: 17px;
    height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background-color: ${({ theme }) => theme.red1};
    border-radius: 50px;
  }

  .head-list {
    min-width: 350px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .MuiChip-root {
      font-weight: 500;
      color: ${({ theme }) => theme.text1};
      background-color: transparent;
      border: 1px solid ${({ theme }) => theme.border1};
      &:hover {
        background-color: ${({ theme }) => theme.hoverBg1};
      }
      svg {
        width: 18px;
        height: 18px;
        margin-left: 12px;
        fill: ${({ theme }) => theme.svg1};
      }
    }
  }

  .profile-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: contain;
  }

  .profile-container-space {
    width: 160px;
    display: flex;
    justify-content: flex-end;
  }

  .profile-container {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 5px 5px 7px;
    border-radius: 100px;
    max-width: 160px;
    height: 38px;
    &:hover {
      background-color: ${({ theme }) => theme.hoverBg1};
    }

    span {
      font-size: 15px;
      margin-left: 5px;
    }
    > div {
      > div svg {
        position: relative;
        top: 4px;
        width: 7px;
        > path:nth-child(2) {
          fill: #333333;
        }
      }
    }
  }

  .beforelogin-profile-container {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    width: 35px;
    height: 35px;
    margin: 0px 12px;
    &:hover {
      background-color: ${({ theme }) => theme.hoverBg1};
    }
    svg {
      fill: ${({ theme }) => theme.svg1};
    }
  }

  .mode-dropdown {
    .selectContainer select {
      width: 150px;
      border: 2px solid #dbdbdb;
      background-size: auto 40%;
      background-color: #fff;
    }
  }

  .header-user-name-block {
    text-align: left;
    padding: 4px;
    max-width: 110px;
  }

  .header-display-name {
    font-size: 13px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors[2]};
  }

  .header-user-name {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #828282;
  }

  .menu-view {
    background: rgba(0, 0, 0, 0.4);
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1060;
    height: 100%;
    transition-duration: 0.3s;
  }
  .d-none {
    display: none;
  }
  ${Sidenav} {
    margin-top: 20px;
    .sidenav-container {
      box-shadow: none;
    }
  }
  .menu-list {
    background: #fff;
    overflow-y: scroll;
    width: 70%;
    height: 100%;
    transition-duration: 0.3s;
  }
  .h-menu {
    display: none;
  }

  .header-auth-btn {
    display: flex;
    > button {
      width: 100px;
      white-space: nowrap;
      margin-left: 12px;
    }
  }
  @media only screen and (max-width: 599px) {
    .notify-icon {
      display: flex;
    }
  }

  @media only screen and (max-width: ${MediaQueries.desktopMinwidth}) {
    .title {
      width: auto;
      padding-right: 20px;
      display: none;
      font-size: 25px;
    }
    .h-menu {
      margin-left: 10px;
      display: block;
    }
    .head-list {
      min-width: 36%;
      padding-left: 10px;
      > span {
        padding-left: 6px;
      }
    }
  }

  @media screen and (max-width: ${MediaQueries.tabletMaxwidth}) {
    .menu-list {
      overflow-y: auto;
    }
    ${Sidenav} {
      width: auto;
      width: 83%;
    }
    .header-auth-btn {
      > button {
        width: auto;
      }
    }
  }
`;

export const SearchContainer = styled.div`
  .search-content-container {
    margin-top: 12px;
    .search-tip {
      font-size: 14px;
      color: ${({ theme }) => theme.text1};
    }
  }
  .search-action {
    .InputContainerStyle {
      width: 100%;
    }
    display: flex;
    align-items: center;
    path {
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .search-user-container {
    border-radius: 8px;
    padding: 6px 6px;
    margin: 8px 4px;
    box-shadow: ${({ theme }) => theme.boxShadow1};
  }
  .search-headline {
    font-size: 14px;
    margin-top: 4px;
  }
  .search-user-item {
    display: flex;
    .search-user-details {
      margin-left: 6px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      .search-displayName {
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        &:hover {
          span {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
      .search-username {
        font-size: 14px;
        color: #828282;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  .search-close-icon {
    margin-left: 8px;
    &:hover {
      cursor: pointer;
      path {
        fill: ${({ theme }) => theme.fieldText1};
      }
    }
  }
  .search-input {
    width: 100%;
  }
  .see-all-results {
    width: 100%;
    text-align: center;
    padding-top: 0px;
  }
`;

export const ProfilePopoverContent = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.text1};
  .language-close-icon {
    display: block;
    padding: 12px 18px 6px;
    position: sticky;
    top: 0;
  }
  >div {
    display: flex;
    padding: 12px 18px;
    align-items: center;
    justify-content: space-between;
    width: 160px;
    cursor: pointer;
    border-radius: 8px;
    &:hover {
      background-color: ${({ theme }) => theme.hoverBg1};
    }
    &.profile-item:nth-child(4) {
      color: ${({ theme }) => theme.red1};
      svg {
        fill: ${({ theme }) => theme.red1};
      }
    }
    .profile-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 10px;
    }
    .profile-content-item {
      display: flex;
      align-items: center;
      &:nth-child(1) svg {
        width: 19px;
        height: 19px;
      }
      svg {
        width: 18px;
        height: 18px;
        margin-right: 12px;
        fill: ${({ theme }) => theme.text1};
      }
    }
    .preview-language {
      font-size: 13px;
      color: #828282;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 107px;
    }
    .profile-content-icon {
      width: 22px;
      height: 22px;
      fill: ${({ theme }) => theme.text1};
      position: relative;
      top: 2px;
    }
    .language-list {
      display: block;
      flex-direction: column;
      margin-left: 30px;
    }
  }

  .language-active-item {
    color: #1976d2;
    font-weight: 500;
    background-color: ${({ theme }) => theme.hoverBg1};
  }
`;
